import { useMemo } from 'react';
import { useProject, useProjectIdDetailPartCode } from 'hooks/useProject';
import { IContent, Question, SurveyListLatestContent } from 'interface/project/projectInfo';

interface ICommProjectProps {
  isLoading: boolean;
  projectDetailInfo: IContent;
  surveyRootInfo: SurveyListLatestContent;
  surveyInfo: Question[];
  surveyAddInfo: Question[];
}
function useProjectSurveyInfo(): ICommProjectProps {
  const { urlProjectId, urlPartCode } = useProject();
  const { data, isLoading } = useProjectIdDetailPartCode(urlProjectId, urlPartCode);
  const projectDetailInfo = useMemo(() => {
    return data || {};
  }, [data]);
  const surveyRootInfo = useMemo(() => projectDetailInfo?.survey || {}, [projectDetailInfo?.survey]);
  const surveyInfo = useMemo(() => projectDetailInfo?.survey?.questions || [], [projectDetailInfo?.survey?.questions]);
  const surveyAddInfo = useMemo(
    () => projectDetailInfo?.surveyAdd?.questions || [],
    [projectDetailInfo?.surveyAdd?.questions],
  );

  return { isLoading, projectDetailInfo, surveyInfo, surveyRootInfo, surveyAddInfo };
}

export default useProjectSurveyInfo;
